import { defineStore } from 'pinia';
import { onRequestDefaultError, requests, removeNulls } from '🔗/utils/requests';
import stores from '🔗/stores';

const defaultEvents = (state, entity_type) => ({
    curator: async(entity_id, field, value) => await state.curator(entity_type, entity_id, field, value),
    owner: async(entity_id, field, value) => await state.owner(entity_type, entity_id, field, value)
});


const useEntityApi = defineStore('entity-api', {
    state: () => ({
        default: {
            ARTIST: {
                curator: {
                    MAX_TRACK_CREATE_COUNT: +import.meta.env.VITE_APP_MAX_TRACK_CREATE_COUNT
                }
            }
        }
    }),
    getters: {
        artist: (state) => defaultEvents(state, 'ARTIST'),
        release: (state) => defaultEvents(state, 'RELEASE'),
        track: (state) => defaultEvents(state, 'TRACK'),
        playlist: (state) => defaultEvents(state, 'PLAYLIST')
    },
    actions: {
        async curator(entity_type, entity_id, field, value) {
            let curatorSettings = { ...(this.default[entity_type]?.curator || {}) };

            try {
                const result = await this.$http({
                    method: 'GET',
                    url: `/entity-settings/curator/${entity_type}/${entity_id}`,
                    // signal: requests.signal('entity-curator-get')
                });

                if (result.status === 200) {
                    const { data } = result;

                    curatorSettings = { ...curatorSettings, ...(data?.curatorSettings || {}) };
                }
            } catch (e) {
                onRequestDefaultError(e);
            }

            if (value === undefined) {
                if (field === undefined) {
                    return curatorSettings;
                }

                return curatorSettings ? curatorSettings[field] : undefined;
            }

            curatorSettings[field] = value;

            try {
                const result = await this.$http({
                    method: 'PUT',
                    url: `/entity-settings/curator/${entity_type}/${entity_id}`,
                    data: curatorSettings,
                    // signal: requests.signal('entity-curator-set')
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },

        async owner(entity_type, entity_id, field, value) {
            let ownerSettings = { ...(this.default[entity_type]?.owner || {}) };

            try {
                const result = await this.$http({
                    method: 'GET',
                    url: `/entity-settings/owner/${entity_type}/${entity_id}`,
                    // signal: requests.signal('entity-owner-get')
                });

                if (result.status === 200) {
                    const { data } = result;

                    ownerSettings = { ...ownerSettings, ...(data?.ownerSettings || {}) };
                }
            } catch (e) {
                onRequestDefaultError(e);
            }

            if (value === undefined) {
                if (field === undefined) {
                    return ownerSettings;
                }

                return ownerSettings ? ownerSettings[field] : undefined;
            }

            ownerSettings[field] = value;

            try {
                const result = await this.$http({
                    method: 'PUT',
                    url: `/entity-settings/owner/${entity_type}/${entity_id}`,
                    data: ownerSettings,
                    // signal: requests.signal('entity-owner-set')
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        }
    }
});

export default useEntityApi;
